module.exports = __webpack_public_path__ + "static/media/aug.2affa598.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Aya/aug.png
// module id = 154
// module chunks = 0